import * as React from 'react'
import { CMSState, Url } from '../../../../cms/blocks/types.gen'
import { Action, IOWidget, mk_widget, async, loadingAsyncState, AsyncState, nothing, mk_pair } from 'widgets-for-react'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { toMonth } from '../../../../cms/blocks/utils.gen'
import * as i18next from 'i18next'

export type MilkPricesTableBlockProps<customBlockData, extra_images> = {
  block_index: number
  milk_prices: AsyncState<WordPress.MilkPricesResponse>
  title: string
  description: string
  kind:
  | 'milk_prices_table'
  | 'bio_milk_prices_table'
  | 'protein_fat_lactose_table'
  | 'bio_protein_fat_lactose_table'
}

export function MilkPricesTableBlock<customBlockData, extra_images>(
  props: MilkPricesTableBlockProps<customBlockData, extra_images>,
  options?: { key?: string }
): IOWidget<
  CMSState<customBlockData, extra_images, PublicSite_CustomPageData>,
  Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>
> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: setState => (
        <section className={`block block--milkprices`} key={options && options.key ? options.key : 'text-milkprices'}>
          <div className="block__inner container--xl grid--block">
            {async<WordPress.MilkPricesResponse>(_ => nothing())(props.milk_prices)
              .map(a =>
                setState(s => {
                  let currentBlock = s.blocks.get(props.block_index) as any
                  if (currentBlock.kind === 'milkPricesTableBlock') {
                    currentBlock = {
                      ...currentBlock,
                      value: mk_pair(
                        {
                          ...currentBlock.value.fst,
                          milk_prices: a(props.milk_prices)
                        },
                        currentBlock.value.snd
                      )
                    }
                  }

                  return {
                    ...s,
                    blocks: s.blocks.set(props.block_index, currentBlock)
                  }
                })
              )
              .run(_ => null)}

            {props.milk_prices.kind == 'loaded' && props.kind == 'milk_prices_table' && (
              <>
                {props.title && (
                  <header className="block__header">
                    <h2 className="block__title typo--3xl">{props.title}</h2>
                    {props.description && (
                      <div
                        className="block__intro"
                        dangerouslySetInnerHTML={{ __html: props.description }}
                      />
                    )}
                  </header>
                )}

                <div className="block__content">
                  <div className="milk-prices-wrapper">
                    <MilkPricesTable items={props.milk_prices.value.acf.prices} />
                  </div>
                </div>
              </>
            )}

            {props.milk_prices.kind == 'loaded' && props.kind == 'bio_milk_prices_table' && (
              <>
                {props.title && (
                  <header className="block__header">
                    <h2 className="block__title typo--3xl">{props.title}</h2>
                    {props.description && (
                      <div
                        className="block__intro"
                        dangerouslySetInnerHTML={{ __html: props.description }}
                      />
                    )}
                  </header>
                )}

                <div className="block__content">
                  <div className="milk-prices-wrapper">
                    <MilkPricesTable items={props.milk_prices.value.acf.bio_prices} />
                  </div>
                </div>
              </>
            )}

            {props.milk_prices.kind == 'loaded' && props.kind == 'protein_fat_lactose_table' && (
              <>
                {props.title && (
                  <header className="block__header">
                    <h2 className="block__title typo--3xl">{props.title}</h2>
                    {props.description && (
                      <div
                        className="block__intro"
                        dangerouslySetInnerHTML={{ __html: props.description }}
                      />
                    )}
                  </header>
                )}

                <div className="block__content">
                  <div className="milk-prices-wrapper">
                    <ProteinFatLactosePricesTable items={props.milk_prices.value.acf.prices} />
                  </div>
                </div>
              </>
            )}
            {props.milk_prices.kind == 'loaded' && props.kind == 'bio_protein_fat_lactose_table' && (
              <>
                {props.title && (
                  <header className="block__header">
                    <h2 className="block__title typo--3xl">{props.title}</h2>
                    {props.description && (
                      <div
                        className="block__intro"
                        dangerouslySetInnerHTML={{ __html: props.description }}
                      />
                    )}
                  </header>
                )}

                <div className="block__content">
                  <div className="milk-prices-wrapper">
                    <ProteinFatLactosePricesTable items={props.milk_prices.value.acf.bio_prices} />
                  </div>
                </div>
              </>
            )}
          </div>
        </section>
      )
    })
}

type TableState = {
  activeYear: WordPress.MilkPrice
}

type TableProps = {
  items: Array<WordPress.MilkPrice>
}

class MilkPricesTable extends React.Component<TableProps, TableState> {
  constructor(props) {
    super(props)

    this.state = {
      activeYear: props.items.length > 0 && props.items[0] ? props.items[0] : null
    }
  }

  render() {
    return (
      <div className="tabs-wrapper">
        <ul className="tabs">
          {this.props.items && this.props.items.map((data: WordPress.MilkPrice) => (
            <li
              key={data.year}
              className={this.state.activeYear && this.state.activeYear == data ? 'active' : ''}
              onClick={_ => this.setState({ activeYear: data })}
            >
              {data.year}
            </li>
          ))}
        </ul>
        <div className="tab-content-wrapper">
          {this.state.activeYear && (
            <div className="tab-content">
              <h3>{this.state.activeYear.year}</h3>
              {window.wp.language == 'en' && this.state.activeYear.year_description_en && (
                <p>
                  <em>{this.state.activeYear.year_description_en}</em>
                </p>
              )}
              {window.wp.language == 'nl' && this.state.activeYear.year_description_nl && (
                <p>
                  <em>{this.state.activeYear.year_description_nl}</em>
                </p>
              )}
              <table className="prices-table">
                <thead>
                  <tr>
                    <th>{i18next.t('blocks.milkPricesTableBlock.labels.month')}</th>
                    <th>{i18next.t('blocks.milkPricesTableBlock.labels.guaranteed_price')}</th>
                    <th>{i18next.t('blocks.milkPricesTableBlock.labels.average_price')}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.activeYear.prices_per_month.map(row => (
                    <tr>
                      <td>{i18next.t(`blocks.milkPricesTableBlock.months.${(+row.month).toString()}`)}</td>
                      <td>{row.milk_price}</td>
                      <td>{row.average_price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    )
  }
}

class ProteinFatLactosePricesTable extends React.Component<TableProps, TableState> {
  constructor(props) {
    super(props)

    this.state = {
      activeYear: props.items.length > 0 && props.items[0] ? props.items[0] : null
    }
  }

  render() {
    return (
      <div className="tabs-wrapper">
        <ul className="tabs">
          {this.props.items && this.props.items.map((data: WordPress.MilkPrice) => (
            <li
              key={data.year}
              className={this.state.activeYear && this.state.activeYear == data ? 'active' : ''}
              onClick={_ => this.setState({ activeYear: data })}
            >
              {data.year}
            </li>
          ))}
        </ul>
        <div className="tab-content-wrapper">
          {this.state.activeYear && (
            <div className="tab-content">
              <h3>{this.state.activeYear.year}</h3>
              <table className="prices-table">
                <thead>
                  <tr>
                    <th>{i18next.t('blocks.milkPricesTableBlock.labels.month')}</th>
                    <th>{i18next.t('blocks.milkPricesTableBlock.labels.protein')}</th>
                    <th>{i18next.t('blocks.milkPricesTableBlock.labels.fat')}</th>
                    <th>{i18next.t('blocks.milkPricesTableBlock.labels.lactose')}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.activeYear.prices_per_month.map(row => (
                    <tr>
                      <td>{i18next.t(`blocks.milkPricesTableBlock.months.${(+row.month).toString()}`)}</td>
                      <td>{row.protein_price}</td>
                      <td>{row.fat_price}</td>
                      <td>{row.lactose_price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    )
  }
}
